import React from 'react';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const ApprovalRulesSetup = () => {
  return (
    <div className="approval-rules-setup" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <Link 
            to="/workflow/management" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Workflow Management
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Approval Rules Setup</h1>
          <p className="text-gray-600 mt-2">
            Configure automated approval workflows and business rules.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-purple-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <CheckCircle size={48} className="text-purple-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Approval Workflows</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Configure automated approval workflows with customizable rules and escalation paths. 
              This feature will be available in v2.0.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> Advanced approval workflows with conditional logic, 
                multi-level approvals, and automated escalation rules.
              </p>
            </div>

            <button className="bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors flex items-center mx-auto">
              <CheckCircle size={20} className="mr-2" />
              Configure Rules
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalRulesSetup;
